import { useParams } from 'react-router-dom'
import { useServices } from '@percent/cause-dashboard/context/serviceContext/ServiceContext'
import { useLocale } from '@percent/cause-dashboard/common/hooks/useLocale/useLocale'
import { useQuery } from '@percent/utility'
import { useTranslation } from 'react-i18next'

export const useGrantDetails = () => {
  const { candidateId } = useParams<{ candidateId: string }>()
  const { grantsService } = useServices()
  const { t } = useTranslation()
  const { locale } = useLocale()

  const {
    data: candidate,
    isLoading,
    error
  } = useQuery(['/candidates', candidateId, locale], grantsService.getCandidate, {
    candidateId: candidateId || '',
    locale
  })

  const {
    data: documents,
    isLoading: isDocumentsLoading,
    refetch: refetchDocuments
  } = useQuery(['/documents', candidateId], grantsService.getCandidateDocuments, { candidateId: candidateId || '' })

  return {
    program: {
      id: candidate?.program?.id || '',
      name: candidate?.program?.name || t('grants.grantDetails.programOverview.unknownName'),
      description: candidate?.program?.description || t('grants.grantDetails.programOverview.noDescription'),
      partnerName: candidate?.program?.partnerName || ''
    },
    candidate: candidate || null,
    documents:
      documents?.map(document => ({
        url: document.url
      })) || [],
    refetchDocuments,
    isLoading: isLoading || isDocumentsLoading,
    error: error
  }
}
